import { LayoutGrid, Globe, Code2, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SERVICES = [
  {
    icon: LayoutGrid,
    tag: "Primary focus",
    title: "SaaS applications",
    copy: "We design and deliver software products that help businesses work more efficiently, reduce friction in key workflows, and gain more value from their operational processes.",
    accent: true,
  },
  {
    icon: Globe,
    tag: "Managed for you",
    title: "Website as a Service",
    copy: "Professional business websites built, hosted and maintained by us from £49 per month. Get a polished online presence without the upfront cost or the ongoing hassle of managing it yourself.",
    accent: false,
  },
  {
    icon: Code2,
    tag: "When you need it",
    title: "Bespoke Development",
    copy: "Where off-the-shelf software is not the right fit, we provide specialist bespoke development to support unique business requirements, internal systems, and tailored workflows.",
    accent: false,
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 md:py-32 bg-slate-50 border-y border-slate-100"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <Reveal className="max-w-3xl">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-brand-blue">
            What we do
          </p>
          <h2 className="mt-4 font-heading font-700 text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-navy">
            Software products and specialist development for small and medium
            sized businesses.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">
            We help businesses improve the way they work through focused
            software solutions. Our priority is building useful, product-led
            tools, while also offering bespoke development where a business
            needs something more specific.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {SERVICES.map((service, i) => {
            const Icon = service.icon;
            return (
              <Reveal key={service.title} delay={i * 0.1}>
                <div
                  data-testid={`service-card-${i}`}
                  className={`h-full rounded-2xl border p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${
                    service.accent
                      ? "bg-brand-navy border-brand-navy text-white"
                      : "bg-white border-slate-200"
                  }`}
                >
                  <div
                    className={`inline-flex h-14 w-14 items-center justify-center rounded-xl ${
                      service.accent
                        ? "bg-white/10 text-white"
                        : "bg-brand-blue/10 text-brand-blue"
                    }`}
                  >
                    <Icon className="h-7 w-7" strokeWidth={2} />
                  </div>
                  <p
                    className={`mt-6 text-xs font-semibold tracking-[0.18em] uppercase ${
                      service.accent ? "text-brand-sky" : "text-brand-blue"
                    }`}
                  >
                    {service.tag}
                  </p>
                  <h3
                    className={`mt-2 font-heading font-700 text-2xl tracking-tight ${
                      service.accent ? "text-white" : "text-brand-navy"
                    }`}
                  >
                    {service.title}
                  </h3>
                  <p
                    className={`mt-4 leading-relaxed ${
                      service.accent ? "text-slate-200" : "text-slate-600"
                    }`}
                  >
                    {service.copy}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
